import { render, staticRenderFns } from "./SpeakingVideoDetail.vue?vue&type=template&id=9740d876&scoped=true&"
import script from "./SpeakingVideoDetail.vue?vue&type=script&lang=js&"
export * from "./SpeakingVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpeakingVideoDetail.vue?vue&type=style&index=0&id=9740d876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9740d876",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VCardTitle,VFlex,VIcon,VLayout,VTextarea})
